var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"noroom-icon"},[_c('img',{attrs:{"src":_vm.noroomicon,"alt":""}})]),_c('div',{staticClass:"noroom-text"},[_vm._v("暂时没有更多房型哦～")])])}
var staticRenderFns = []

export { render, staticRenderFns }